import { render, staticRenderFns } from "./inventory-products-form.vue?vue&type=template&id=543e1cb8"
import script from "./inventory-products-form.vue?vue&type=script&lang=js"
export * from "./inventory-products-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports